import { MaxByteSizeParam } from './types';

export const MEGABYTE = 1048576;

const DEFAULT = 20 * MEGABYTE;

const SUPPORTING_DOCUMENTS: MaxByteSizeParam = {
  'application/pdf': 20 * MEGABYTE,
  default: DEFAULT,
  /**
   * We limit images to 5Mb because our CF that rotates them has problems with heavy docs.
   */
  'image/bmp': 5 * MEGABYTE,
  'image/jpeg': 5 * MEGABYTE,
  'image/png': 5 * MEGABYTE,
};

export const FILE_SIZE = {
  DEFAULT,
  SUPPORTING_DOCUMENTS,
} as const;
